


















































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { FitLayout } from '@/fit-ui';
import FitBackground from '@/fit-components/background/index.vue';
import LineChart from '@/components/line.vue';
import HistogramChart from '@/components/histogram.vue';
import Header from '@/components/header.vue';
import VHeader from '@/components/sub-header.vue';
import RollMessage from '@/components/roll-message.vue';
import { hideLoading, showLoading } from '@/fit-components/loading/main';
import { showBusinessError, showDialog } from '@/fit-components/dialog/main';
import { queryNews, queryCaseNumber, queryCases } from '../api';
import { getLast14DaysHistogramData } from '../business/process';
import { NcovDataType, ChartType } from '../types';
import { util, biHottag, language, url } from '@tencent/ppd-base-libs';
import { RouteName } from '../router';
import { isThirtPart } from '../business/third-part';
import { i18n } from '@/i18n';
import Wegoods from '@/components/wegoods/index.vue';
import BlackListBanner from '@/components/black-list-banner/index.vue';
import Banner from '@/components/banner/index.vue';
import { formatDate, diff_filter, thousands, getLang } from '../util/index';
import FitThirdProduct from '@/fit-components/third-product/index.vue';
import { tmpPromBannerData } from '../config/tmp-prom-banner';
import { Notice } from '@tencent/wphk-components-notice';

function timeAdd0(str) {
  if (str.length <= 1) {
    str = `0${str}`;
  }
  return str;
}

@Component({
  components: {
    LineChart,
    HistogramChart,
    FitBackground,
    FitLayout,
    Header,
    VHeader,
    Wegoods,
    RollMessage,
    BlackListBanner,
    Banner,
    Notice,
  },
  filters: {
    diff_filter,
    thousands,
  },
})
export default class HomePage extends Vue {
  caseData = [];
  newsData = [];
  rollMessage: any[] = [];
  introData: { jump_link: string; color: string; name: string }[] = [
    {
      jump_link: 'https://www.chp.gov.hk/files/pdf/prevention_workplace.pdf',
      color: '#ffffff',
      name: i18n('防疫上班攻略'),
    },
    {
      jump_link: 'https://www.chp.gov.hk/files/pdf/reduce_social_contact_to_protect_yourself_and_others.pdf',
      color: '#ffffff',
      name: i18n('預防社區傳播'),
    },
    {
      jump_link: 'https://www.chp.gov.hk/files/pdf/guidelines_for_hand_hygiene_chi.pdf',
      color: '#ffffff',
      name: i18n('正確潔手方法'),
    },
    { jump_link: 'https://www.chp.gov.hk/files/pdf/utrap_tc.pdf', color: '#ffffff', name: i18n('妥善保養排水渠') },
  ];
  // thirdProduct: { name: string; desc: string; link: string }[] = [
  //  /* {name:i18n('Hygienium搓手液'), desc:i18n("歐洲製作，70%乙醇"), link:"https://hygienium.asia?t=1"},*/
  //  /* {name:i18n('口罩及消毒產品'), desc:i18n("美嘉健康旅遊提供"), link:"http://www.ohsmk.com/app/index.php?i=5&c=entry&m=ewei_shopv2&do=mobile"},*。
  //  /* {name:i18n('pricecom防疫產品'), desc:i18n("口罩及消毒清潔用品"), link:"https://offers.price.com.hk/index.php?id=729"}, */
  //  {name:i18n('3層过滤口罩'), desc:i18n("100% 香港製造"), link:"https://offers.price.com.hk/product_detail.php?pid=193716"},
  //  {name:i18n('日本MASTO口罩'), desc:i18n("獨立包裝超柔軟"), link:"https://offers.price.com.hk/product_detail.php?pid=193690"},
  //  {name:i18n('更多口罩消毒產品'), desc:i18n("由美嘉健康提供"), link:"http://www.ohsmk.com/app/index.php?i=5&c=entry&m=ewei_shopv2&do=mobile"}
  // ];
  entryName = 'entryName';
  fileName = 'fileName';
  skuModuleName = 'sdfsdf';
  serviceData: { jump_link: string; color: string; name: string }[] = [];
  hospitalData: { name: string; link: string; link_en: string }[] = [
    {
      name: 'Prenetics',
      link: 'https://projectscreen.co/',
      link_en: 'https://projectscreen.co/',
    },
    {
      name: '养和医院',
      link: 'https://covid.hksh.com/Forms/PreRegistration/Covid19TestIntro',
      link_en: 'https://covid.hksh.com/Forms/PreRegistration/Covid19TestIntro',
    },
    {
      name: '港怡医院',
      link: 'https://gleneagles.hk/tc/',
      link_en: 'https://gleneagles.hk/',
    },
    {
      name: '港安医院-荃湾',
      link: 'https://www.twah.org.hk/tc/main',
      link_en: 'https://www.twah.org.hk/en/main',
    },
  ];
  showAllNews = false;
  showShareDialog = false;
  systemTime = 0;
  lang = language.getLanguage();
  last14DaysHistogramData = {};
  data = {
    columns: ['date', 'newCase'],
    rows: [],
  };
  ratData = {
    columns: ['date', 'newCase'],
    rows: [],
  };
  totalPositiveData = {
    columns: ['date', 'newCase'],
    rows: [],
  };
  typeData = {
    columns: [
      i18n('本地个案'),
      i18n('可能本地个案'),
      i18n('输入个案'),
      i18n('與本地個案有關'),
      i18n('與可能本地有關'),
      i18n('與輸入個案有關'),
    ],
    rows: [],
  };
  casesData = [];
  legendMap = {
    newCase: i18n('新增個案'),
  };
  isThirtPart = isThirtPart();
  showPanel = false;
  statementShow = false;
  showChart = true;
  showChartType: ChartType = ChartType.ByTotalNewCase;
  EChartType = ChartType;

  reportTagList; // 用于记录SKU模块单个商品上报情况
  productMain;
  bannerVaccineData = {
    // 疫情banner
    link: 'https://www.fdh.labour.gov.hk/Leaflet_Vaccine.pdf',
  };
  bannerData = {
    image_cn: '',
    image_en: '',
    link: '',
  }; // 运营banner

  // 临时加的定向运营banner
  tmpPromBannerData = tmpPromBannerData;

  get newestCaseData() {
    if (this.caseData.length) {
      return this.caseData[this.caseData.length - 1];
    }
    return {};
  }

  get updateTimeStr() {
    const newest = this.newestCaseData;
    // @ts-ignore
    const { updateTime } = newest;
    return updateTime ? formatDate(new Date(updateTime * 1000)) : '-';
  }
  get ifShowShare() {
    const adtag = url.getUrlParam('adtag');
    const hideShare = url.getUrlParam('hideShare');
    return adtag !== 'yellowbar' && !hideShare;
  }
  handleShowAllNews() {
    this.showAllNews = true;
  }
  openMoreText(index) {
    this.$set(this.newsData[index], 'opened', true);
  }
  switchChartType(type: ChartType, index) {
    biHottag(`wallet.cvirus.home.switchchart${index + 1}_click`);
    this.showChartType = type;
  }

  goHealthCode() {
    biHottag('wallet.cvirus.home.healthcode_click');
    setTimeout(() => {
      window.location.href = `https://www.ehc.gov.hk/portal/index.jsp?lang=${this.lang}`;
    }, 300);
  }

  goHospital() {
    biHottag('wallet.cvirus.home.finddoc_click');
    setTimeout(() => {
      window.location.href =
        'https://www.finddoc.com/vc/wechat?utm_source=wechat&utm_medium=in-app&utm_campaign=covid19-test';
    }, 300);
  }
  goInsureService(index) {
    let link;
    if (index === 0) {
      link = 'https://heyavo.com/zh-hk/wechat-in-app?product=covid';
    } else if (index === 1) {
      link = 'https://heyavo.com/zh-hk/wechat-in-app?product=travel%2Fgba-wechat';
    }
    biHottag(`wallet.cvirus.home.avo${index + 1}_click`);

    setTimeout(() => {
      window.location.href = link;
    }, 300);
  }
  goJoox() {
    biHottag('wallet.cvirus.home.banner3_brow');
    setTimeout(() => {
      biHottag('wallet.cvirus.home.banner3_click');
      window.location.href = 'https://forms.office.com/r/BRnmiT1Wqd';
    }, 300);
  }
  // 新闻辟谣
  goIntroService(index) {
    biHottag('wallet.cvirus.home.tips_click');
    setTimeout(() => {
      window.location.href = 'https://vp.fact.qq.com/home?stopic=hk&ADTAG=jiugongge';
    }, 300);
  }
  goService(index) {
    biHottag(`wallet.cvirus.home.service${index + 1}_click`);
    setTimeout(() => {
      window.location.href = this.serviceData[index].jump_link;
    }, 32);
  }
  handleChartClick() {
    biHottag('wallet.cvirus.home.chart_click');
  }
  goEverPlace() {
    biHottag('wallet.cvirus.home.situation_click');
    this.$router.push({
      name: RouteName.areaQuery,
      params: {
        pageType: 'building',
      },
    });
  }
  goMoreHospital() {
    biHottag('wallet.cvirus.home.moreinst_click'); // 疫情首页-核酸检测机构-查看更多
    this.$router.push({
      name: RouteName.nucleicTestTable,
    });
  }
  goAllHospital() {
    biHottag('wallet.cvirus.home.testinginst_click'); // 疫情首页-快速查询入口-核酸检测机构
    this.$router.push({
      name: RouteName.nucleicTestTable,
    });
  }
  goStation() {
    biHottag('wallet.cvirus.home.ctrlpoints_click'); // 疫情首页-快速查询入口-管制站安排
    this.$router.push({
      name: RouteName.stationTable,
    });
  }
  goDiscovery() {
    biHottag('wallet.cvirus.home.discover_click'); // 疫情首页-快速查询入口-热门服务
    setTimeout(() => {
      window.location.href =
        'https://hkwallet.moneydata.hk/fcgi-bin/app/ewallet_bindcard/ewallet_discovery_index.fcgi?ADTAG=YQZZ';
    }, 300);
  }
  goReturnHK() {
    biHottag('wallet.cvirus.home.returnhk_click'); // 疫情首页-快速查询入口-回港易
    let url = 'https://www.coronavirus.gov.hk/chi/return2hk-scheme.html';
    if (this.lang === 'en') {
      url = 'https://www.coronavirus.gov.hk/eng/return2hk-scheme.html';
    }
    setTimeout(() => {
      window.location.href = url;
    }, 300);
  }
  goPersonCases() {
    biHottag('wallet.cvirus.home.cases_click');
    this.$router.push({
      name: RouteName.cases,
      params: {
        pageType: 'cases',
      },
    });
  }
  goEverTraffic() {
    biHottag('wallet.cvirus.home.transport_click');
    this.$router.push({
      name: RouteName.areaTable,
      params: {
        pageType: 'traffic',
      },
    });
  }
  showAnswer() {
    biHottag('wallet.cvirus.home.nowconfirmed_click'); // 疫情首页-顶部数据区域-现有确诊疑问
    showDialog({ content: i18n('現有陽性個案=累計陽性個案-出院-死亡') });
  }
  openShareDialog() {
    biHottag('wallet.cvirus.home.share_click');
    this.showShareDialog = true;
  }
  closeShareDialog() {
    this.showShareDialog = false;
  }
  activated() {
    util.changeTitle(i18n('全球防疫動態追蹤'));
    console.log('activated');
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 300);
  }
  // 构造滚动轮播信息list
  createRollMessage(config) {
    const newsData = config.hkDisease || [];
    const recommendData = config.recommend || [];
    const _newsData: any[] = []; // 构造与推荐相同的数据结构

    newsData.map((item) => {
      if (item.recommend != '1') return; // 过滤新闻中设置为滚动消息的
      item.type = 'news';
      _newsData.push(item);
    });
    recommendData.map((item) => {
      item.type = 'recommend';
      return item;
    });
    // 合并配置的推荐信息
    const messages = _newsData.concat(JSON.parse(JSON.stringify(recommendData)));
    return messages;
  }
  // 如果轮播点击的新闻滚动至锚点，没有打开的新闻需要展开
  handleMessageClick(index) {
    if (index > 3) this.showAllNews = true;
  }

  handleCVBannerClick() {
    biHottag('wallet.cvirus.home.banner_cv_click');
    setTimeout(() => {
      window.location.href =
        'https://mp.weixin.qq.com/s?__biz=MzA3MjUzODc1Mg%3D%3D&mid=2650341208&idx=1&sn=2753d013162eade21a0c0430a5f0390f&chksm=871090b7b06719a16bf3f9164c58de7fc775d7f39b1a1f88b2dfc06e66fed4225488df586a3b&mpshare=1&scene=1&srcid=0218E5oJjvtTevAYg3HU88y8&sharer_sharetime=1645170517382&sharer_shareid=353d6fda5e0695ec772bdb5957295de6#rd';
      // 'https://prom.wechatpay.com.hk/app/promotion/gov_coupons/gov_coupon_home_page.cgi?ADTAG=epidemic#/';
    }, 300);
  }
  // 运营banner点击
  handleBannerClick() {
    biHottag('wallet.cvirus.home.banner_click');

    setTimeout(() => {
      window.location.href = this.bannerData.link;
    }, 300);
  }
  // handleBannerVaccineClick() {
  //   // 疫情banner点击
  //   biHottag('wallet.cvirus.home.banner_vaccine_click');

  //   setTimeout(() => {
  //     window.location.href = this.bannerVaccineData.link;
  //   }, 300);
  // }
  async created() {
    biHottag('wallet.cvirus.home.index_brow');
    showLoading();
    const [newsErr, newsData] = await util.to(queryNews());
    if (newsErr) {
      console.log(newsErr);
      hideLoading();
      showBusinessError(newsErr);
      return;
    }
    this.rollMessage = this.createRollMessage(newsData);
    this.newsData = newsData.hkDisease;
    this.serviceData = newsData.service;
    this.bannerData = newsData.banner;
    const [err, data] = await util.to(queryCaseNumber());
    if (err) {
      hideLoading();
      // showBusinessError(err);
      this.showChart = false;
      return;
    }
    hideLoading();
    this.caseData = data.f_ncov_data;
    this.systemTime = +data.serverTime;
    // const last14DaysHistogramData = await getLast14DaysHistogramData(this.lang);
    if (err) {
      hideLoading();
      return;
    }
    // 注释掉14天案例表格
    // this.last14DaysHistogramData = last14DaysHistogramData;
    // this.casesData = f_ncov_data;
    // const { f_ncov_data } = data;
    /* this.data.rows = data.f_ncov_data.map(item => {
      const newItem = { ...item };
      newItem.newCase = newItem.confirmed_diff;
      // 时间处理
      newItem.date = newItem.date.replace(
        /(\d{2})\/(\d{2})\/(\d{4})/gim,
        ($0, day, month) => {
          return `${month}.${day}`;
        }
      );
      return newItem;
    });*/

    // 排除掉2020年的数据
    const newYearData = data.ncov_data.filter((item) => {
      const date = item['As of date'].replace(
        /(\d{2})\/(\d{2})\/(\d{4})/gim,
        ($0, day, month, year) => `${year}/${month}/${day}`,
      );
      return new Date().getTime() - new Date(date).getTime() < 30 * 24 * 3600 * 1000; // 取出180天内的数据展示
    });

    this.data.rows = newYearData.map((item, index) => {
      const newItem = {
        newCase: 0,
        date: '',
      };
      const nextItem = newYearData[index];
      if (nextItem) {
        // 如果有下一个
        newItem.newCase = nextItem['Number of confirmed cases diff'];
        // 时间处理
        newItem.date = item['As of date'].replace(
          /(\d{2})\/(\d{2})\/(\d{4})/gim,
          ($0, day, month) => `${month}.${day}`,
        );
        return newItem;
      }
      return null;
    });
    this.ratData.rows = newYearData.map((item, index) => {
      const newItem = {
        newCase: 0,
        date: '',
      };
      const nextItem = newYearData[index];
      if (nextItem) {
        // 如果有下一个
        newItem.newCase = nextItem.RAT_Positive_Delta || 0;
        // 时间处理
        newItem.date = item['As of date'].replace(
          /(\d{2})\/(\d{2})\/(\d{4})/gim,
          ($0, day, month) => `${month}.${day}`,
        );
        return newItem;
      }
      return null;
    });
    this.totalPositiveData.rows = newYearData.map((item, index) => {
      const newItem = {
        newCase: 0,
        date: '',
      };
      const nextItem = newYearData[index];
      if (nextItem) {
        // 如果有下一个
        newItem.newCase =
          (parseInt(nextItem['Number of confirmed cases diff'], 10) || 0) +
          (parseInt(nextItem.RAT_Positive_Delta, 10) || 0);
        // 时间处理
        newItem.date = item['As of date'].replace(
          /(\d{2})\/(\d{2})\/(\d{4})/gim,
          ($0, day, month) => `${month}.${day}`,
        );
        return newItem;
      }
      return null;
    });
    // this.data.rows.pop(); // 最后一个肯定为null

    setTimeout(() => {
      // 元素点击蒙层监听
      const needmaskEl = document.querySelectorAll('.touchmask');
      needmaskEl.forEach((v, i) => {
        v.addEventListener('touchstart', this.showMask);
        v.addEventListener('touchend', this.hideMask);
      });
    }, 1000);
  }
  showMask(e) {
    e.currentTarget.classList.add('showmask');
  }
  hideMask(e) {
    e.currentTarget.classList.remove('showmask');
  }
}
